export const lockIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.50004 8.33333V5C7.50004 4.33696 7.76343 3.70107 8.23227 3.23223C8.70111 2.76339 9.337 2.5 10 2.5C10.6631 2.5 11.299 2.76339 11.7678 3.23223C12.2366 3.70107 12.5 4.33696 12.5 5V8.33333M15 6.66667L15.7642 16.6025C15.773 16.717 15.7581 16.8321 15.7204 16.9405C15.6826 17.049 15.6229 17.1485 15.5449 17.2328C15.4669 17.317 15.3723 17.3843 15.267 17.4303C15.1618 17.4763 15.0482 17.5 14.9334 17.5H5.06671C4.95187 17.5 4.83827 17.4763 4.73304 17.4303C4.62781 17.3843 4.53322 17.317 4.4552 17.2328C4.37719 17.1485 4.31743 17.049 4.27969 16.9405C4.24195 16.8321 4.22703 16.717 4.23587 16.6025L5.00004 6.66667H15Z"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const userIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83301 14.1667V15C5.83301 15.221 5.92081 15.433 6.07709 15.5893C6.23337 15.7455 6.44533 15.8333 6.66634 15.8333H13.333C13.554 15.8333 13.766 15.7455 13.9223 15.5893C14.0785 15.433 14.1663 15.221 14.1663 15V14.1667C14.1663 13.5036 13.9029 12.8677 13.4341 12.3989C12.9653 11.9301 12.3294 11.6667 11.6663 11.6667H8.33301C7.66997 11.6667 7.03408 11.9301 6.56524 12.3989C6.0964 12.8677 5.83301 13.5036 5.83301 14.1667ZM12.4997 6.66667C12.4997 7.32971 12.2363 7.96559 11.7674 8.43443C11.2986 8.90327 10.6627 9.16667 9.99967 9.16667C9.33663 9.16667 8.70075 8.90327 8.23191 8.43443C7.76307 7.96559 7.49967 7.32971 7.49967 6.66667C7.49967 6.00362 7.76307 5.36774 8.23191 4.8989C8.70075 4.43006 9.33663 4.16667 9.99967 4.16667C10.6627 4.16667 11.2986 4.43006 11.7674 4.8989C12.2363 5.36774 12.4997 6.00362 12.4997 6.66667Z"
      stroke="black"
      stroke-width="2"
    />
  </svg>
);

export const searchIcon = (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25 25L20.3333 20.3333M19.6667 10.3333C19.6667 11.559 19.4253 12.7727 18.9562 13.905C18.4872 15.0374 17.7997 16.0663 16.933 16.933C16.0663 17.7997 15.0374 18.4872 13.905 18.9562C12.7727 19.4253 11.559 19.6667 10.3333 19.6667C9.10766 19.6667 7.89399 19.4253 6.76162 18.9562C5.62925 18.4872 4.60035 17.7997 3.73367 16.933C2.86699 16.0663 2.1795 15.0374 1.71046 13.905C1.24141 12.7727 1 11.559 1 10.3333C1 7.85798 1.98333 5.48401 3.73367 3.73367C5.48401 1.98333 7.85798 1 10.3333 1C12.8087 1 15.1827 1.98333 16.933 3.73367C18.6833 5.48401 19.6667 7.85798 19.6667 10.3333Z"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
);

export const EditIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 19H5C4.73478 19 4.48043 18.8946 4.29289 18.7071C4.10536 18.5196 4 18.2652 4 18V17C4 16.2044 4.31607 15.4413 4.87868 14.8787C5.44129 14.3161 6.20435 14 7 14H8M12 8C12 8.79565 11.6839 9.55871 11.1213 10.1213C10.5587 10.6839 9.79565 11 9 11C8.20435 11 7.44129 10.6839 6.87868 10.1213C6.31607 9.55871 6 8.79565 6 8C6 7.20435 6.31607 6.44129 6.87868 5.87868C7.44129 5.31607 8.20435 5 9 5C9.79565 5 10.5587 5.31607 11.1213 5.87868C11.6839 6.44129 12 7.20435 12 8ZM19.441 9.559C19.6182 9.7361 19.7589 9.9464 19.8548 10.1779C19.9507 10.4093 20.0001 10.6574 20.0001 10.908C20.0001 11.1586 19.9507 11.4067 19.8548 11.6381C19.7589 11.8696 19.6182 12.0799 19.441 12.257L13.372 18.326L10 19L10.674 15.628L16.744 9.558C16.9211 9.3809 17.1313 9.24042 17.3627 9.14458C17.5941 9.04874 17.8421 8.9994 18.0925 8.9994C18.3429 8.9994 18.5909 9.04874 18.8223 9.14458C19.0537 9.24042 19.2639 9.3809 19.441 9.558V9.559Z"
      stroke="black"
      stroke-width="2"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
  </svg>
);

export const removeIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 12H20M4 18V17C4 16.2044 4.31607 15.4413 4.87868 14.8787C5.44129 14.3161 6.20435 14 7 14H11C11.7956 14 12.5587 14.3161 13.1213 14.8787C13.6839 15.4413 14 16.2044 14 17V18C14 18.2652 13.8946 18.5196 13.7071 18.7071C13.5196 18.8946 13.2652 19 13 19H5C4.73478 19 4.48043 18.8946 4.29289 18.7071C4.10536 18.5196 4 18.2652 4 18ZM12 8C12 8.79565 11.6839 9.55871 11.1213 10.1213C10.5587 10.6839 9.79565 11 9 11C8.20435 11 7.44129 10.6839 6.87868 10.1213C6.31607 9.55871 6 8.79565 6 8C6 7.20435 6.31607 6.44129 6.87868 5.87868C7.44129 5.31607 8.20435 5 9 5C9.79565 5 10.5587 5.31607 11.1213 5.87868C11.6839 6.44129 12 7.20435 12 8Z"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const addIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 12H20M18 14V10M4 18V17C4 16.2044 4.31607 15.4413 4.87868 14.8787C5.44129 14.3161 6.20435 14 7 14H11C11.7956 14 12.5587 14.3161 13.1213 14.8787C13.6839 15.4413 14 16.2044 14 17V18C14 18.2652 13.8946 18.5196 13.7071 18.7071C13.5196 18.8946 13.2652 19 13 19H5C4.73478 19 4.48043 18.8946 4.29289 18.7071C4.10536 18.5196 4 18.2652 4 18ZM12 8C12 8.79565 11.6839 9.55871 11.1213 10.1213C10.5587 10.6839 9.79565 11 9 11C8.20435 11 7.44129 10.6839 6.87868 10.1213C6.31607 9.55871 6 8.79565 6 8C6 7.20435 6.31607 6.44129 6.87868 5.87868C7.44129 5.31607 8.20435 5 9 5C9.79565 5 10.5587 5.31607 11.1213 5.87868C11.6839 6.44129 12 7.20435 12 8Z"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const tickIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.08333 9.58333L9.16667 11.6667L12.5 8.33333M17.5 10C17.5 10.9849 17.306 11.9602 16.9291 12.8701C16.5522 13.7801 15.9997 14.6069 15.3033 15.3033C14.6069 15.9997 13.7801 16.5522 12.8701 16.9291C11.9602 17.306 10.9849 17.5 10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10Z"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const crossIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 7.5L7.5 12.5M7.5 7.5L12.5 12.5M17.5 10C17.5 10.9849 17.306 11.9602 16.9291 12.8701C16.5522 13.7801 15.9997 14.6069 15.3033 15.3033C14.6069 15.9997 13.7801 16.5522 12.8701 16.9291C11.9602 17.306 10.9849 17.5 10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10Z"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const expireIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.46417 10H13.5358M17.5 10C17.5 10.9849 17.306 11.9602 16.9291 12.8701C16.5522 13.7801 15.9997 14.6069 15.3033 15.3033C14.6069 15.9997 13.7801 16.5522 12.8701 16.9291C11.9602 17.306 10.9849 17.5 10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10Z"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const HomeIcon = (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.387 16.9987L13.6937 20.3053L21.9603 12.0387M29.5437 20.8253L31.032 19.337C31.3391 19.0299 31.5827 18.6654 31.7489 18.2642C31.9151 17.863 32.0007 17.4329 32.0007 16.9987C32.0007 16.5644 31.9151 16.1344 31.7489 15.7332C31.5827 15.3319 31.3391 14.9674 31.032 14.6603L29.5437 13.172C29.2366 12.8649 28.9931 12.5004 28.8269 12.0991C28.6608 11.6979 28.5753 11.2679 28.5753 10.8337V8.732C28.5753 7.85502 28.227 7.01395 27.6068 6.39383C26.9867 5.77371 26.1456 5.42533 25.2687 5.42533H23.1653C22.7311 5.42547 22.301 5.34002 21.8998 5.17386C21.4986 5.00771 21.134 4.76412 20.827 4.457L19.3387 2.96867C19.0316 2.66156 18.6671 2.41796 18.2658 2.25175C17.8646 2.08555 17.4346 2 17.0003 2C16.5661 2 16.136 2.08555 15.7348 2.25175C15.3336 2.41796 14.9691 2.66156 14.662 2.96867L13.1737 4.457C12.8666 4.76404 12.502 5.00759 12.1008 5.17374C11.6996 5.33989 11.2696 5.42538 10.8353 5.42533H8.73367C8.29929 5.42512 7.86912 5.51048 7.46775 5.67656C7.06637 5.84264 6.70165 6.08617 6.39442 6.39324C6.08719 6.70032 5.84348 7.06492 5.6772 7.46621C5.51092 7.8675 5.42533 8.29762 5.42533 8.732V10.8353C5.42533 11.7137 5.077 12.5537 4.457 13.1737L2.96867 14.662C2.66156 14.9691 2.41796 15.3336 2.25175 15.7348C2.08555 16.136 2 16.5661 2 17.0003C2 17.4346 2.08555 17.8646 2.25175 18.2658C2.41796 18.6671 2.66156 19.0316 2.96867 19.3387L4.457 20.827C5.077 21.447 5.42533 22.287 5.42533 23.1653V25.2687C5.42533 26.1456 5.77371 26.9867 6.39383 27.6068C7.01395 28.227 7.85502 28.5753 8.732 28.5753H10.8353C11.7137 28.5753 12.5537 28.9237 13.1737 29.5437L14.662 31.032C14.9691 31.3391 15.3336 31.5827 15.7348 31.7489C16.136 31.9151 16.5661 32.0007 17.0003 32.0007C17.4346 32.0007 17.8646 31.9151 18.2658 31.7489C18.6671 31.5827 19.0316 31.3391 19.3387 31.032L20.827 29.5437C21.4473 28.9237 22.2884 28.5754 23.1653 28.5753H25.2687C26.1456 28.5753 26.9867 28.227 27.6068 27.6068C28.227 26.9867 28.5753 26.1456 28.5753 25.2687V23.1653C28.5753 22.287 28.9237 21.4453 29.5437 20.8253Z"
      stroke="#2E2E30"
      stroke-width="3.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const logoutIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 9H1M13 9L9 13M13 9L9 5M12 1H14C14.7956 1 15.5587 1.31607 16.1213 1.87868C16.6839 2.44129 17 3.20435 17 4V14C17 14.7956 16.6839 15.5587 16.1213 16.1213C15.5587 16.6839 14.7956 17 14 17H12"
      stroke="#2E2E30"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const prevIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 19L8 12L15 5"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const nextIcon = (
  <svg
    width="6"
    height="7"
    viewBox="0 0 6 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.804 5.86V4.9L3.96 3.136L0.804 1.372V0.412L5.412 3.016V3.256L0.804 5.86Z"
      fill="#676D7A"
    />
  </svg>
);

export const bagIcon = (
  <svg
    width="20"
    height="30"
    viewBox="0 0 26 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.63187 12.6667V6C7.63187 4.67392 8.1666 3.40215 9.11843 2.46447C10.0703 1.52678 11.3612 1 12.7073 1C14.0534 1 15.3444 1.52678 16.2962 2.46447C17.248 3.40215 17.7828 4.67392 17.7828 6V12.6667M22.8582 9.33333L24.4096 29.205C24.4276 29.434 24.3973 29.6642 24.3207 29.8811C24.244 30.098 24.1227 30.297 23.9643 30.4655C23.806 30.6341 23.6139 30.7686 23.4003 30.8605C23.1866 30.9525 22.956 31 22.7229 31H2.69176C2.45862 31 2.22799 30.9525 2.01435 30.8605C1.80072 30.7686 1.60868 30.6341 1.4503 30.4655C1.29192 30.297 1.17061 30.098 1.09398 29.8811C1.01736 29.6642 0.987071 29.434 1.00502 29.205L2.55642 9.33333H22.8582Z"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
